export default {
    methods: {
        formatRemoveSeconds(timeString) {
            const timearr = timeString.split(':');
            const time = timearr[0]+":"+timearr[1];
            return time;
        }
    }
}